import React from "react";
import moneyback from "../../../../assets/landingPage/90-day-money-back.png"

const Gurantee = () => {
    return (
        <div className="px-4"
        >
            <div className="max-w-5xl mx-auto  bg-white border-[#132C4D] border-4 relative">
                <div className="flex flex-col items-center text-center relative z-10">
                    {/* <!-- Money Back Seal --> */}
                    <div className="w-80 h-80 flex justify-center">
                        <img
                            src={moneyback}
                            alt="100% Money Back Guarantee Seal"
                            className="w-full h-full object-contain hover:rotate-2 duration-300 ease-in-out hover:opacity-90"
                        />
                    </div>
                    {/* <!-- Headings --> */}
                    <h2 className="text-[40px] font-bold text-gray-900 mb-2">
                        100% Satisfaction
                    </h2>
                    <h3 className="text-[40px] font-bold text-[#FF1300] mb-6">
                        180 Day Money Back Guarantee
                    </h3>
                    {/* <!-- Description --> */}
                    <p className="max-w-3xl text-black mb-10 text-[20px] leading-10 font-light">
                        We’re confident you’ll love Lung Renew. Every bottle is backed by our ironclad 180-day guarantee. Whether you notice results in days or weeks, you’re covered. If you’re not satisfied, we’ll refund your full purchase—no questions asked.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Gurantee;
